module.exports = __webpack_public_path__ + "heart.aede7ed8c62224f26289fce8d9a45c95.gif";